import { WORDMARK_ON_DARK, WORDMARK_ON_LIGHT } from "../logo";

/**
 * The company wordmark, on whichever background it finds itself.
 *
 * CopperRidge's lockup sets "RIDGE" and "ROOFING" in one flat colour and the
 * rest in copper, so there is no single file that survives both a white card
 * and a dark one — whichever half is not copper disappears, and what
 * disappears is the company's own name.
 *
 * Both files are drawn and CSS hides one (`.loginlogo.on-light` /
 * `.on-dark`). Choosing in CSS rather than in JavaScript means it follows the
 * same rules as every colour token — the system preference, and the explicit
 * `data-theme` that overrides it — instead of forming a second opinion about
 * the theme that could disagree with the first.
 *
 * A component rather than the markup twice: it is drawn on the sign-in form,
 * on the forgotten-password panel and on the set-password screen, and a fix to
 * one of three copies is the kind that gets missed.
 */
export function Wordmark() {
  return (
    <>
      {/* Both carry the name. `display: none` takes an element out of the
          accessibility tree as well as off the screen, so exactly one of these
          is ever announced — and naming only the light one would leave a
          screen reader on a dark screen with no company at all. */}
      <img
        className="loginlogo on-light"
        src={WORDMARK_ON_LIGHT}
        alt="CopperRidge Roofing & Exteriors"
      />
      <img
        className="loginlogo on-dark"
        src={WORDMARK_ON_DARK}
        alt="CopperRidge Roofing & Exteriors"
      />
    </>
  );
}
